import { CalendarPlus } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { isIOS } from "@/lib/push";

const cls = "flex items-center gap-1.5 text-xs rounded-lg border border-white/10 px-2 py-1 text-slate-300 hover:border-sky-400/40 hover:text-sky-200 transition-colors";

const googleLink = (w, end) => {
  const d = (s) => s.replaceAll("-", "");
  const after = new Date(`${end}T00:00:00Z`);
  after.setUTCDate(after.getUTCDate() + 1);
  const places = (w.cities || []).join(", ");
  const q = new URLSearchParams({
    action: "TEMPLATE",
    text: `Trip to ${w.country}${places ? ` (${places})` : ""}`,
    dates: `${d(w.target_date)}/${after.toISOString().slice(0, 10).replaceAll("-", "")}`,
    details: `Planned on ${window.location.origin}`,
    location: w.country,
  });
  return `https://calendar.google.com/calendar/render?${q}`;
};

// iPhone opens .ics straight into Calendar; elsewhere offer Google too
export const AddToCalendar = ({ w, index }) => {
  if (!w.target_date) return null;
  const ics = `${process.env.REACT_APP_BACKEND_URL}/api/wishlist/${w.id}/calendar.ics`;
  const label = <><CalendarPlus size={13} /> Calendar</>;
  if (isIOS()) return <a href={ics} className={cls} data-testid={`wish-calendar-${index}`}>{label}</a>;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={cls} data-testid={`wish-calendar-${index}`}>{label}</DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem asChild><a href={googleLink(w, w.end_date || w.target_date)} target="_blank" rel="noreferrer" data-testid={`wish-calendar-google-${index}`}>Google Calendar</a></DropdownMenuItem>
        <DropdownMenuItem asChild><a href={ics} download data-testid={`wish-calendar-ics-${index}`}>Apple / Outlook / other (.ics)</a></DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
